import { render } from "./appVersion.vue?vue&type=template&id=55703f92&scoped=true"
import script from "./appVersion.vue?vue&type=script&lang=js"
export * from "./appVersion.vue?vue&type=script&lang=js"

import "./appVersion.vue?vue&type=style&index=0&id=55703f92&scoped=true&lang=css"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55703f92"]])

export default __exports__